import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'periscope.skeleton.label',
		defaultMessage: 'Loading',
		description: 'Label associated to the page skeleton while data is being requested.',
	},
	suggestionsLabel: {
		id: 'periscope.suggestions-skeleton.label',
		defaultMessage: 'Suggestions loading',
		description: 'Label associated to the page suggestions skeleton while data is being requested.',
	},
	insightsLabel: {
		id: 'periscope.insights-skeleton.label',
		defaultMessage: 'Developer insights loading',
		description: 'Label associated to the page insights skeleton while data is being requested.',
	},
	workItemsLabel: {
		id: 'periscope.work-items-skeleton.work-items-label',
		defaultMessage: 'Work items loading',
		description: 'Label associated to the page work items skeleton while data is being requested.',
	},
	workItemsVulnTabLabel: {
		id: 'periscope.work-items-skeleton.work-items-vuln-tab-label',
		defaultMessage: 'Work items vulnerability tab loading',
		description:
			'Label associated to the page vulnerability tab work items skeleton while data is being requested.',
	},
	workItemsDeploymentTabLabel: {
		id: 'periscope.work-items-skeleton.work-items-deployment-tab-label',
		defaultMessage: 'Work items deployment tab loading',
		description:
			'Label associated to the page deployment tab work items skeleton while data is being requested.',
	},
	onCallPanelLabel: {
		id: 'periscope.on-call-skeleton.label',
		defaultMessage: 'On call panel loading',
		description:
			'Label associated to the page deployment tab on call panel skeleton while data is being requested',
	},
});
